<template>
  <div id="questionview">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>Last 200 Questions</h1>
      </v-row>
    </v-container>
    <div>
     <div class="green--text text-center">{{ errorText }}</div>
     <div class="text-right"><v-btn color="primary text-center" @click="save">Save</v-btn></div>
      <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <!-- 
    <div class="filtersub">
       <div class="second">
          <v-text-field  v-model="search"  label="Type Question or option(answers)" class="mx-4 searchplayer"></v-text-field> 
       </div> 
       <div class="third">
           <v-btn color="primary text-center" @click.prevent="searchdata">Search</v-btn>
       </div>
    </div>
     :search="search"  -->
     <v-data-table 
       :headers="headers" 
       :mobile-breakpoint="0" 
       :items="itemsWithSno"  
      
       hide-default-footer  
       disable-pagination>
       <template v-slot:item="{ item }"  >
         <tr :class="item.color">
          <td>{{ item.sno }}</td>
         
          <td class="text-left">
            {{ item.question }}
            <div class="options">
              <div v-if="item.option_a">A. {{item.option_a}}</div> 
              <div v-if="item.option_b">B. {{item.option_b}}</div>
              <div v-if="item.option_c">C. {{item.option_c}}</div>
              <div v-if="item.option_d">D. {{item.option_d}}</div>
            </div>
          </td>
           <td>{{ item.last_200_correct_attempts_percent }}</td>
          <td>
            <v-select class="difficulty" hide-details :items="difficulty" @change="updateStatus(item)" v-model="item.difficulty"></v-select> 
          </td>
        </tr>
      </template>   
     </v-data-table>
     <!--<infinite-loading  @infinite="getList"></infinite-loading>-->
    </div>
     
  </div>  

</template>
<script>
export default {
  name: "Questionview",
  data() {
    return {
      mobileBreakpoint: 600,
      dialog:false,
      error: false,
      errorText:'',
      desserts:[],
      editedItem:[],
      search:'', 
      page:1,
      categorylist:'',
      category:'',
      overlay: false,
      optionval:'',
      difficulty:["Easy","Medium","Hard","Difficult","Very Difficult"],
    };
  },
  computed: {
     headers(){
        let headers = [
              { text:"#", value: "sno", width:'3%' },
              { text:"Question  ",align: "question",value: "question",sortable: true, width:'76%'},
              { text:'Correct %' , width:'7%'},
              { text:"Action", value: "", width:'14%' },
         ]
         return headers
      },
       itemsWithSno() {
          return this.desserts.map((d, index) => ({ ...d, sno: index + 1,keyval:index }))
       },
  },
  created(){
     this.getList();
  },
  methods: {
    updateStatus(item)
    {
       var checkeditem = this.checkExist(item.id);
        
       if(checkeditem === false)
       {
          this.editedItem.push({"question_id":item.id,"difficulty":item.difficulty}); 
       }
       else
       {
          this.editedItem[checkeditem].difficulty = item.difficulty;  
       }
        
    },
    checkExist(id){
      var array = this.editedItem;
      if(array.length > 0)
      {
        for(var i=0;i<array.length;i++) 
        {
          if(array[i].question_id === id)
            {return i;}
        }
      }
      return false;
    },
    save(){
        for(var i = 0; i < this.desserts.length; i++)
        {
           if(this.checkExist(this.desserts[i].id) === false)
           {
             this.editedItem.push({"question_id":this.desserts[i].id,"difficulty":this.desserts[i].difficulty});
           }
        } 
        
          this.$store.dispatch("unableQuestion",{"data":this.editedItem}).then((response) => {
          
            this.errorText = response.data.message;
            this.getList();
         });      
      
    },
    getList()
    {
       var parameter = "page="+this.page;
       if(this.category != '')
       {
         parameter = parameter+"&category_d="+this.category;
       }

       if(this.search != '')
       {
         parameter = parameter+"&question_string="+this.search;
       } 
       this.desserts = [];
       this.$store.dispatch("getdisableQuestionsList",{paramters:parameter}).then((response) => {
          if(response.data.length > 0)
          {
             this.page += 1;
             this.desserts = response.data;
             //$state.loaded();
          }
          else
          {
           // $state.complete();
          }
       });
     },
     
  }
};
</script>
<style scoped>
.options {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    margin-bottom: 8px;
}
.radio-single-sec {align-items: center;}
.filtersub{display:flex; width:98%;margin:auto;align-items: center;}
.filtersub div.first{flex: 0 0 20%}
.filtersub div.second{flex: 0 0 91%}
.filtersub div.third{flex: 0 0 10%}
.radio-single-sec .first {flex: 0 0 15%;}
.radio-single-sec .second {flex: 0 0 85%;}

</style>